export class FleetTaxModel {
  [key: string]: any;

  dpvat!: number;
  ipvaAndLicensingFee!: number;
  autoInsurance!: number;
  rcfv!: number;
  licensing!: number;
}
